import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';

const SubscriptionCancel: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div style={{
      maxWidth: '600px',
      margin: '4rem auto',
      padding: '2rem',
      textAlign: 'center'
    }}>
      <Helmet>
        <title>Paiement annulé - EdenPlaisir.com</title>
        <meta name="description" content="Vous avez annulé le processus de paiement." />
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <div style={{
        width: '80px',
        height: '80px',
        margin: '0 auto 2rem',
        borderRadius: '50%',
        background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <svg
          width="48"
          height="48"
          viewBox="0 0 20 20"
          fill="white"
        >
          <path
            fillRule="evenodd"
            d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
            clipRule="evenodd"
          />
        </svg>
      </div>

      <h1 style={{
        fontSize: '2rem',
        fontWeight: '700',
        color: '#1a1a1a',
        marginBottom: '1rem'
      }}>
        Paiement annulé
      </h1>

      <p style={{
        fontSize: '1.125rem',
        color: '#666',
        marginBottom: '2rem'
      }}>
        Vous avez annulé le processus de paiement. Aucun montant n'a été débité.
      </p>

      <div style={{
        display: 'flex',
        gap: '1rem',
        justifyContent: 'center'
      }}>
        <button
          onClick={() => navigate('/')}
          style={{
            padding: '0.75rem 1.5rem',
            borderRadius: '8px',
            border: '1px solid #e5e7eb',
            background: 'white',
            color: '#374151',
            fontWeight: '500',
            cursor: 'pointer'
          }}
        >
          Retour à l'accueil
        </button>
        
        <button
          onClick={() => navigate('/subscriptions')}
          style={{
            padding: '0.75rem 1.5rem',
            borderRadius: '8px',
            border: 'none',
            background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
            color: 'white',
            fontWeight: '600',
            cursor: 'pointer'
          }}
        >
          Voir les plans
        </button>
      </div>
    </div>
  );
};

export default SubscriptionCancel;


